var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backShow),expression:"backShow"}],staticClass:"page-back",on:{"click":_vm.goBack}},[_vm._v(" 返回")]),_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.currentPageTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }